import { Box } from '@mantine/core';

type Props = {
  children: React.ReactNode;
};

export function SideBarItemWrapper({ children }: Props) {
  return <Box p={20}>{children}</Box>;
}
